import { Exclude, Expose, Type } from 'class-transformer';
import { ApiProperty } from '@nestjs/swagger';
import { PreRockSheetInterface } from '../interfaces/pre-rock-sheet.interface';
import { JobNoteDto } from '../../job-note/dtos/job-note.dto';

@Exclude()
export class PreRockSheetDto implements PreRockSheetInterface {
  //
  // Job fields
  //
  @ApiProperty({
    title: 'Job ID (synonym for React Admin only)',
  })
  @Expose()
  id!: string;

  @ApiProperty({
    title: 'Job ID',
    description: 'The job number/identifier',
  })
  @Expose()
  jobId!: string;

  @ApiProperty({
    title: 'Job Lot',
    description: 'The lot number/identifier',
  })
  @Expose()
  jobLot!: string;

  @ApiProperty({
    type: 'date-time',
    title: 'Created At',
  })
  @Expose()
  @Type(() => Date)
  createdAt!: Date;

  @ApiProperty({
    title: 'Address',
  })
  @Expose()
  address1!: string;

  @ApiProperty({
    title: 'Builder ID',
  })
  @Expose()
  builderId!: string;

  @ApiProperty({
    title: 'Current Phase ID',
  })
  @Expose()
  currentPhaseId!: string;

  //
  // Subdivision fields
  //

  @ApiProperty({
    title: 'Subdivision ID',
  })
  @Expose()
  subdivisionId!: string;

  @ApiProperty({
    title: 'Supervisor User ID',
  })
  @Expose()
  supervisorUserIds!: string;

  @ApiProperty({
    title: 'Supervisor Full Name',
  })
  @Expose()
  supervisorFullNames!: string;

  @ApiProperty({
    title: 'Region Id',
  })
  @Expose()
  regionId!: string;

  @ApiProperty({
    type: () => [JobNoteDto],
    title: 'Job Notes',
  })
  @Expose()
  jobNotes?: JobNoteDto[];

  @ApiProperty({
    type: 'string',
    title: 'PhaseStructureType',
  })
  @Expose()
  phaseStructureType!: string;
}
